import { render, staticRenderFns } from "./TransProgramPersonWDis.vue?vue&type=template&id=3edf9377"
import script from "./TransProgramPersonWDis.vue?vue&type=script&lang=ts"
export * from "./TransProgramPersonWDis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports